import { command } from "@lookiero/messaging";
const REMOVE_NOTIFICATION = "REMOVE_NOTIFICATION";
const removeNotification = ({ aggregateId }) => command({ aggregateId, name: REMOVE_NOTIFICATION });
export { REMOVE_NOTIFICATION, removeNotification };
